var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMusicSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 454,
    viewBox: "0 0 454 454",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M449.253 25.4572L428.076 4.25724C423.538 -0.285612 414.462 -1.7999 408.412 2.74296L343.368 46.6572C340.343 49.6858 337.318 52.7144 337.318 57.2572C337.318 61.8001 338.83 66.3429 341.856 69.3715L261.686 149.629L10.5884 226.857C4.5379 228.371 0 234.429 0 240.486C0 246.543 3.02527 252.6 9.07581 255.629L145.213 308.629L198.155 444.914C199.668 450.971 205.718 454 211.769 454C217.819 454 223.87 449.457 225.383 443.4L307.065 182.943L269.249 220.8C263.199 226.857 254.123 226.857 248.072 220.8C245.047 217.771 243.534 213.229 243.534 210.2L363.032 90.5715L373.621 101.172L384.209 111.772C387.235 114.8 390.26 116.314 394.798 116.314H396.31C400.848 116.314 405.386 113.286 406.899 110.257L450.765 45.143C455.303 39.0858 455.303 31.5144 449.253 25.4572ZM222.357 296.514C219.332 299.543 214.794 301.057 211.769 301.057C208.744 301.057 204.206 299.543 201.18 296.514L157.314 252.6C151.264 246.543 151.264 237.457 157.314 231.4C163.365 225.343 172.44 225.343 178.491 231.4L222.357 275.314C228.408 281.371 228.408 290.457 222.357 296.514Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMusicSession);
export default __webpack_public_path__ + "static/media/music_session.02c705dd86daf042376501e1aef39779.svg";
export { ForwardRef as ReactComponent };